<template>
	<div class="video-section-box">
		<div
			:class="[
				'e-learning-box',
				{
					'e-learning-box-finished': isSectionDone,
					'active': isSelected,
				},
			]"
			@click="collapse(id)"
			:id="'video' + id"
		>
			<img
				v-if="isNotTest()"
				src="images/icons/chevron-down-green.svg"
				alt
			/>
			<h3 v-if="isNotTest()">sekcja:{{ id }} - {{ name }}</h3>
			<h3 v-else>Test wiedzy</h3>
			<div v-if="isNotTest()">
				<span
					v-if="!isSectionDone"
					class="d-flex justify-content-between"
				>
					<span>
						<b>{{ finishedLessons }} / {{ movies.length }}</b>
						lekcji ukończyłeś
					</span>
					<span class="text-right">
						pozostało:
						<b>{{ lessonsTime }}</b>
					</span>
				</span>
				<span v-else>Ukończyłeś wszystkie lekcje !</span>
			</div>
			<div v-else>
				<span v-if="!isSectionDone">{{ cms.beforeTest }}</span>
				<div v-else style="width: 100%">
					<span v-if="!testMessage">{{ cms.info[0] }}</span>
					<span v-else class="text-danger mb-2">{{
						testMessage
					}}</span>
					<button
						class="btn btn-primary d-block mt-2"
						@click.prevent="startQuiz()"
					>
						rozpocznij
					</button>
				</div>
			</div>
			<span
				v-if="!isSectionDone && isNotTest()"
				class="e-learning-bar"
				:style="{
					width:
						calculatedWidth(finishedLessons, movies.length) + '%',
				}"
			></span>
		</div>
		<div :class="['e-learning-collapse', { active: isSelected }]">
			<div
				v-for="(movie, i) in movies"
				:key="i"
				class="collapse-lesson"
				@click="selectMovie(movie)"
			>
				<div
					class="collapse-img-container d-flex align-items-center mr-3"
				>
					<img
						v-if="movie.done"
						src="images/statusPage/ty-success.png"
						alt
						class="my-0"
					/>
					<learning-progress-circle
						v-else
						:movies="1"
						:finishedLessons="0"
						:collapsed="false"
					/>
				</div>
				<div class="collapse-content-container">
					<h4>{{ movie.name }}</h4>
					<div>
						<img src="images/play-video.svg" />
						<p>{{ movieTime(movie.time) }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import LearningProgressCircle from './LearningProgressCircle';
import { eLearningLessons } from '@/mixins/e-learning.js';
import { eLearningModalMethods } from '@/mixins/e-learning-modal.js';
import { mapGetters } from 'vuex';
export default {
	props: {
		id: {
			type: Number,
			required: true,
			default: 0,
		},
		finishedLessons: {
			type: Number,
			required: false,
			default: 0,
		},
		lessonsTime: {
			type: String,
			required: false,
			default: '',
		},
		name: {
			type: String,
			required: true,
			default: '',
		},
		done: {
			type: String,
			required: false,
		},
		movies: {
			type: Array,
			required: false,
			default: function () {
				return [];
			},
		},
		player: Object,
		changeVideo: Boolean,
	},
	data() {
		return {
			cms: {
				/* eslint-disable */

				info: ELEARNING_READY_TEST,
				beforeTest: ELEARNING_BEFORE_TEST,
			},
		};
	},
	components: {
		LearningProgressCircle,
	},
	mixins: [eLearningLessons, eLearningModalMethods],
	computed: {
		...mapGetters(['getCourses']),
		isSectionDone() {
			if (this.id === 0) {
				let finished = 0;
				let all = 0;
				Array.prototype.forEach.call(this.getCourses, (course) => {
					all += course.movies.length;
					for (var i = 0; i < course.movies.length; i++) {
						if (course.movies[i].done) {
							finished += 1;
						}
					}
				});
				return finished === all ? true : false;
			} else {
				return this.finishedLessons === this.movies.length
					? true
					: false;
			}
		},
		isSelected() {
			let selected = sessionStorage.getItem('video') || 0;
			let selectedVideo = selected.length ? JSON.parse(selected) : 0;
			let videoId = selectedVideo ? selectedVideo.id : 0;
			return videoId === this.id;
		},
		testMessage() {
			return this.$store.getters.getTestMessage;
		},
	},
	methods: {
		isNotTest() {
			// test ma id == 0
			return this.id !== 0 ? true : false;
		},
		startQuiz() {
			this.$store.commit('setLearningModal', false);
			this.$store.dispatch('fetchQuizTime');
		},
		selectMovie(movie) {
			let time = movie.time;
			var timeParts = time.split(':');
			time =
				timeParts[0] * 3600000 +
				timeParts[1] * 60000 +
				timeParts[2] * 1000 +
				300000;

			let selected = {
				id: this.id,
				name: this.name,
				movieName: movie.name,
				movieSrc: movie.src,
				movieId: movie.id,
				movieTime: time,
			};
			this.$store.commit('setTemporaryVideo', selected);
			this.player.pauseVideo();
			if (this.changeVideo) {
				this.$store.commit('setLearningModal', true);
			} else {
				const now = new Date();
				let selectedVideo = this.$store.getters.getTemporaryVideo;

				const expirationDate = new Date(
					now.getTime() + this.$store.getters.getTimeToLogout
				);

				sessionStorage.setItem('expirationDate', expirationDate);

				this.$store.dispatch(
					'fetchLogOutTimer',
					this.$store.getters.getTimeToLogout
				);
				this.$store.commit('setSelectedVideo', selectedVideo);
				this.$store.dispatch('generateToken');
			}
			this.$store.commit('setIsLeaving', false);
		},
	},
};
</script>
